import { render, staticRenderFns } from "./OutingEditNeedsMealsTable.vue?vue&type=template&id=de8ee81c&scoped=true&lang=pug"
import script from "./OutingEditNeedsMealsTable.vue?vue&type=script&lang=ts"
export * from "./OutingEditNeedsMealsTable.vue?vue&type=script&lang=ts"
import style0 from "./OutingEditNeedsMealsTable.vue?vue&type=style&index=0&id=de8ee81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8ee81c",
  null
  
)

export default component.exports